<template>
  <layout-view>
    <template v-slot:nav>
      <div class="px-4">

        <v-text-field
            v-model="filter.search"
            placeholder="Поиск..."
            outlined dense hide-details class="mb-4" full-width clearable
        >
          <template v-slot:prepend-inner>
            <v-icon>mdi-magnify</v-icon>
          </template>
        </v-text-field>
      
        <com-branch-autocomplete-multiple :select.sync="filter.comBranchsSelected"/>
      </div>
    </template>
    <template v-slot:content="{height}">
      <n-table-view
          ref="table"
          name="Список"
          :genRequestBuilder="genRequestBuilder"
          :height="height"
          :headers="[
            { text: 'ID', value: 'id', class:'text-no-wrap'},
            { text: 'Услуга', value: 'service.name', class:'text-no-wrap', sortable: true },
            { text: 'Филиал', value: 'service.comBranch.id', class:'text-no-wrap', sortable: true},
            { text: 'Длительность (прайс лист)', value: 'duration', class:'text-no-wrap', sortable: false},
            { text: 'Цена (прайс-лист)', value: 'priceTotal', class:'text-no-wrap', sortable: false},
            { text: 'Длительность специалиста', value: 'duration', class:'text-no-wrap', sortable: false},
            { text: 'Цена специалиста', value: 'priceTotal', class:'text-no-wrap', sortable: false},
            { text: 'Базовая услуга', value: 'priceTotal', class:'text-no-wrap', sortable: false}
          ]"
          :groupBy="groupBy ? 'service.serviceCat.name' : undefined"
          :selectAll.sync="servicesSelectAll"
          :selectIndeterminate="servicesSelectIndeterminate"
      >
        <template v-slot:barActions>
            <div class="d-flex align-center">
              <span class="caption pr-1">Вид:</span>
              <tooltip bottom>
                <v-btn class="mr-2" small depressed icon depresse @click="groupBy=!groupBy" :color="!groupBy ? 'primary' : 'grey'">
                  <v-icon>mdi-format-list-numbered</v-icon>
                </v-btn>
                <template v-slot:content>
                  Списком
                </template>
              </tooltip>

              <tooltip bottom>
                <v-btn class="mr-5" small depressed icon depresse @click="groupBy=!groupBy" :color="groupBy ? 'primary' : 'grey'">
                  <v-icon>mdi-folder-outline</v-icon>
                </v-btn>
                <template v-slot:content>
                  Папки
                </template>
              </tooltip>
              <v-btn
                  v-if="servicesSelects.length>0"
                  @click="$confirm('Удалить услуги','Вы уверены, что хотите удалить выбранные услуги?', ()=>userServicesDelete())"
                  depressed small
                  :disabled="servicesSelects.length===0"
                  class="mr-2"
              >
                Удалить услуги ({{servicesSelects.length}})
              </v-btn>

              <v-btn
                  @click="copyState.modalOpen()"
                  depressed small
                  class="mr-2"
              >
                Копировать услуги
              </v-btn>
              
              <v-btn small depressed @click="createState.modalOpen({userServicesDuration:null,userServicesPriceTotal:null})">Добавить</v-btn>
            </div>
        </template>
        <template v-slot:groupHeader="{ items, isOpen, toggle, headers }">
          <th :colspan="headers.length + (servicesSelectAll !== undefined && 1)" @click="toggle">
            <div class="d-flex align-center">
              <v-icon>
                {{ isOpen ? 'mdi-folder-open-outline' : 'mdi-folder-outline' }}
              </v-icon>

              <span class="text-subtitle-1 pl-3 font-weight-medium">
                {{items[0].service.serviceCat.name}}
              </span>
            </div>
          </th>
        </template>
        <template v-slot:item="{item}">
          <tr @click="updateState.modalOpen($tools.copy(item))" :class="{isInactive: item.service.status==='deleted'}">
            <td>
              <v-checkbox @click.stop="$tools.selectToggle(servicesSelects, item)" :input-value="$tools.isSelect(servicesSelects, item)" class="ma-0 pa-0" dense hide-details />
            </td>
            <td class="text-no-wrap">{{item.id}}</td>
            <td class="text-wrap py-1">
              <v-breadcrumbs class="py-1 px-0">
                <v-breadcrumbs-item v-if="$tools.notNull(item.service, 'serviceCat.serviceCat.serviceCat.serviceCat')" class="caption">{{item.service.serviceCat.serviceCat.serviceCat.serviceCat.name}}</v-breadcrumbs-item>
                <v-breadcrumbs-divider v-if="$tools.notNull(item.service, 'serviceCat.serviceCat.serviceCat.serviceCat')" class="caption px-1">/</v-breadcrumbs-divider>

                <v-breadcrumbs-item v-if="$tools.notNull(item.service, 'serviceCat.serviceCat.serviceCat')" class="caption">{{item.service.serviceCat.serviceCat.serviceCat.name}}</v-breadcrumbs-item>
                <v-breadcrumbs-divider v-if="$tools.notNull(item.service, 'serviceCat.serviceCat.serviceCat')" class="caption px-1">/</v-breadcrumbs-divider>

                <v-breadcrumbs-item v-if="$tools.notNull(item.service, 'serviceCat.serviceCat')" class="caption">{{item.service.serviceCat.serviceCat.name}}</v-breadcrumbs-item>
                <v-breadcrumbs-divider v-if="$tools.notNull(item.service, 'serviceCat.serviceCat')" class="caption px-1">/</v-breadcrumbs-divider>

                <v-breadcrumbs-item v-if="$tools.notNull(item.service, 'serviceCat')" class="caption">{{item.service.serviceCat.name}}</v-breadcrumbs-item>
              </v-breadcrumbs>
              <div class="mb-1">
  
                <tooltip v-if="item.service.status==='deleted'" right>              
                  <chip color="warning" small class="px-3 mr-2">
                    услуга удалена
                  </chip>
                  <template v-slot:content>
                    Услуга удалена из прайс-листа
                  </template>
                </tooltip>

                {{item.service.name}}

                <tooltip v-if="!$tools.isEmpty(item.service.comBranch)" right>              
                  <v-avatar class="mr-2" :color="item.service.comBranch.color" size="10" style="margin-top:-1px"/>  
                  <template v-slot:content>
                    {{ item.service.comBranch.name }}
                  </template>
                </tooltip>
              </div>
              <service-code-view :code="item.service.code"/>
            </td>
            <td class="text-no-wrap">{{ $tools.isEmpty(item.service.comBranch) ? '-' : item.service.comBranch?.name }}</td>
            <td class="text-no-wrap">{{item.service.duration!=0 ? item.service.duration+' мин.' : '-'}}</td>
            <td class="text-no-wrap">{{item.service.priceTotal!='0.00' ? $tools.price(item.service.priceTotal) : '-'}}</td>
            <td class="text-no-wrap">{{item.duration!=0 ? item.duration+' мин.' : '-'}}</td>
            <td class="text-no-wrap">{{item.priceTotal!='0.00' ? $tools.price(item.priceTotal) : '-'}}</td>
            <td class="text-no-wrap">
              <v-icon v-if="item.isBaseService" size="18" color="success" style="margin-top:-1px">mdi-check-circle</v-icon>
              <span v-else>-</span>
            </td>
          </tr>
        </template>
      </n-table-view>
    </template>
    <template v-slot:footer>
      <dialog-view
          :open="copyState.isModalOpen"
          @cancel="copyState.modalClose()"
          :title="`Копировать ${servicesSelects.length>0 ? 'выбранные' : 'все'} услуги`"
      >
        <template v-slot:content>
          <p class="caption">Выберите специалиста к которому хотите скопировать {{ servicesSelects.length>0 ? 'выбранные' : 'все' }} услуги</p>
          <user-autocomplete-single name="Специалист" :select.sync="copyState.modalData" class="my-5" showId :exclude="[parseInt($router.currentRoute.params.id)]" _type="spec"/>
        </template>
        <template v-slot:actions>
          <v-btn text color="primary" @click="copyUserService()" :loading="copyState.isLoading">Копировать</v-btn>
        </template>
      </dialog-view>

      <dialog-view
          :open="createState.isModalOpen"
          @cancel="createState.modalClose()"
          title="Добавить/изменить привязку"
      >
        <template v-slot:content v-if="createState.modalData!==null">
          <!-- <service-select ref="servicesEl" @selected="servicesSelectAction" /> -->

          <services-select :selectedServices.sync="servicesSelect"/>

        </template>
        <template v-slot:actions>
          <v-btn text color="primary" @click="createAction()" :loading="createState.isLoading">Добавить</v-btn>
        </template>
      </dialog-view>
      <dialog-view
          :open="updateState.isModalOpen"
          @cancel="updateState.modalClose()"
          title="Изменить привязку"
      >
        <template v-slot:content v-if="updateState.modalData!==null">
          <v-row class="mt-n2">
            <v-col cols="12">
              {{updateState.modalData.service.name}}
            </v-col>
            <v-col cols="12">
              <v-text-field label="Длительность в минутах" v-model="updateState.modalData.duration" outlined dense hide-details="auto"/>
            </v-col>
            <v-col cols="12">
              <v-text-field label="Цена специалиста" v-model="updateState.modalData.priceTotal" type="number" outlined dense hide-details="auto"/>
            </v-col>
            <v-col cols="12">
               <checkbox-field name="Базовая услуга" :value.sync="updateState.modalData.isBaseService"/>
            </v-col>
            <v-col cols="12">
              <v-btn depressed block @click="serviceCreateUpdateState.modalOpen(updateState.modalData.service)" class="mr-2">Открыть услугу</v-btn>
            </v-col>
          </v-row>
        </template>
        <template v-slot:actions>
          <dialog-view
              title="Удалить привязку к услуге?"
              acceptName="Удалить"
              @acceptAction="deleteUserService(updateState.modalData)"
              :loading="deleteState.isLoading"
              :open="!deleteState.isSuccess"
              class="d-inline-block"
          >
            <template v-slot:activator>
              <v-btn text color="error" class="mr-2">Удалить</v-btn>
            </template>
          </dialog-view>
          <v-btn text color="primary" @click="updateUserService(updateState.modalData)" :loading="updateState.isLoading">Изменить</v-btn>
        </template>
      </dialog-view>
      <service :state="serviceCreateUpdateState" @createdUpdatedDeleted="serviceCreatedUpdatedDeleted" disableDelete/>
    </template>
  </layout-view>
</template>

<script>
import Api from "@/Api";
import NTableView from "@/componentsV2/base/NTableView.vue";
import LayoutView from "@/components/LayoutView.vue";
import ServiceCodeView from "@/views/Service/ServiceCodeView.vue";
import Service from "@/views/Service/Service.vue";
import State from "@/plugins/state";
import DialogView from "@/components/DialogView.vue";
//import ServiceSelect from "@/views/Service/components/ServiceSelect.vue";
import ServicesSelect from "@/components/ServicesSelect.vue";
import axios from "axios";
import Tooltip from "@/componentsV2/base/Tooltip.vue";
import ComBranchAutocompleteMultiple from "@/componentsV2/custom/ComBranchAutocompleteMultiple.vue";
import Chip from "@/componentsV2/base/Chip.vue";
import UserAutocompleteSingle from "@/componentsV2/custom/UserAutocompleteSingle.vue";
import CheckboxField from "@/componentsV2/base/CheckboxField.vue";


import {
  Entity_UserService,
  Entity_User,
  Entity_Service,
  Entity_ServiceCat,
  Entity_ComBranch, Entity_Direction, Entity_DirectionCat, Entity_Nomen, Entity_ServiceLabItem, Entity_Spec
} from "../../../EntityStoreCacheService";

export default {
  components: {
    //ServiceSelect, 
    DialogView, 
    Service, 
    ServiceCodeView, 
    LayoutView, 
    NTableView,
    ServicesSelect,
    Tooltip,
    ComBranchAutocompleteMultiple,
    Chip,
    UserAutocompleteSingle,
    CheckboxField
  },
  data:()=>({
    filter:{
      search:null,
      comBranchsSelected:[] 
    }, 
    serviceCreateUpdateState: new State(),
    createState: new State(),
    deleteState: new State(),
    updateState: new State(),
    copyState: new State(),
    services: [],
    servicesSelect:[],
    servicesSelects:[],
    groupBy: false,

  }),
  watch:{
    filter: {
      handler() {

        this.$refs.table.load();
      },
      deep: true,
    },
  },
  computed: {
    servicesSelectAll:{
      get(){
        return this.$tools.isSelectAll(this.services, this.servicesSelects)
      },
      set(){
        this.$tools.selectAllToggle(this.services, this.servicesSelects)
      }
    },
    servicesSelectIndeterminate:{
      get(){
        return this.$tools.isSelectIntermidiate(this.services, this.servicesSelects)
      },
    },
  },
  methods:{
    genRequestBuilder(page, onPage, sortFields){
      let rb = new Entity_UserService()
      .selects(Entity_UserService.id)
      .selects(Entity_UserService.duration)
      .selects(Entity_UserService.priceTotal)
      .selects(Entity_UserService.isBaseService)
      
      .selects([Entity_UserService.service, Entity_Service.id].join('.'))
      .selects([Entity_UserService.service, Entity_Service.name].join('.'))
      .selects([Entity_UserService.service, Entity_Service.code].join('.'))
      .selects([Entity_UserService.service, Entity_Service.sort].join('.'))
      .selects([Entity_UserService.service, Entity_Service.duration].join('.'))
      .selects([Entity_UserService.service, Entity_Service.priceExec].join('.'))
      .selects([Entity_UserService.service, Entity_Service.priceExpend].join('.'))
      .selects([Entity_UserService.service, Entity_Service.priceTotal].join('.'))
      .selects([Entity_UserService.service, Entity_Service.comment].join('.'))
      .selects([Entity_UserService.service, Entity_Service.commentForClient].join('.'))
      .selects([Entity_UserService.service, Entity_Service.created].join('.'))
      .selects([Entity_UserService.service, Entity_Service.directions, Entity_Direction.id].join('.'))
      .selects([Entity_UserService.service, Entity_Service.directions, Entity_Direction.name].join('.'))
      .selects([Entity_UserService.service, Entity_Service.directions, Entity_Direction.directionCat, Entity_DirectionCat.id].join('.'))
      .selects([Entity_UserService.service, Entity_Service.endDay].join('.'))
      .selects([Entity_UserService.service, Entity_Service.isCompositePrice].join('.'))
      .selects([Entity_UserService.service, Entity_Service.isPriceLock].join('.'))
      .selects([Entity_UserService.service, Entity_Service.isShowForClient].join('.'))
      .selects([Entity_UserService.service, Entity_Service.isShowForExternalService].join('.'))
      .selects([Entity_UserService.service, Entity_Service.isVisitCreateForClient].join('.'))
      .selects([Entity_UserService.service, Entity_Service.isid].join('.'))
      .selects([Entity_UserService.service, Entity_Service.name].join('.'))
      .selects([Entity_UserService.service, Entity_Service.nomen, Entity_Nomen.id].join('.'))
      .selects([Entity_UserService.service, Entity_Service.nomen, Entity_Nomen.code].join('.'))
      .selects([Entity_UserService.service, Entity_Service.nomen, Entity_Nomen.name].join('.'))
      .selects([Entity_UserService.service, Entity_Service.resultDuration].join('.'))
      .selects([Entity_UserService.service, Entity_Service.sort].join('.'))
      .selects([Entity_UserService.service, Entity_Service.serviceLabItems, Entity_ServiceLabItem.id].join('.'))
      .selects([Entity_UserService.service, Entity_Service.serviceLabItems, Entity_ServiceLabItem.name].join('.'))
      .selects([Entity_UserService.service, Entity_Service.serviceLabItems, Entity_ServiceLabItem.code].join('.'))
      .selects([Entity_UserService.service, Entity_Service.spec, Entity_Spec.id].join('.'))
      .selects([Entity_UserService.service, Entity_Service.spec, Entity_Spec.name].join('.'))
      .selects([Entity_UserService.service, Entity_Service.spec, Entity_Spec.color].join('.'))
      .selects([Entity_UserService.service, Entity_Service.startDay].join('.'))
      .selects([Entity_UserService.service, Entity_Service.status].join('.'))
      .selects([Entity_UserService.service, Entity_Service.type].join('.'))
      .selects([Entity_UserService.service, Entity_Service.updated].join('.'))

      .selects([Entity_UserService.service, Entity_Service.comBranch,Entity_ComBranch.id].join('.'))
      .selects([Entity_UserService.service, Entity_Service.comBranch,Entity_ComBranch.name].join('.'))
      .selects([Entity_UserService.service, Entity_Service.comBranch,Entity_ComBranch.color].join('.'))

      .selects([Entity_UserService.service, Entity_Service.serviceCat, Entity_ServiceCat.id].join('.'))
      .selects([Entity_UserService.service, Entity_Service.serviceCat, Entity_ServiceCat.name].join('.'))
      .selects([Entity_UserService.service, Entity_Service.serviceCat, Entity_ServiceCat.isProgram].join('.'))

      .selects([Entity_UserService.service, Entity_Service.serviceCat, Entity_ServiceCat.id].join('.'))
      .selects([Entity_UserService.service, Entity_Service.serviceCat, Entity_ServiceCat.name].join('.'))
      .selects([Entity_UserService.service, Entity_Service.serviceCat, Entity_ServiceCat.isProgram].join('.'))

      .selects([Entity_UserService.service, Entity_Service.serviceCat, Entity_Service.serviceCat, Entity_ServiceCat.id].join('.'))
      .selects([Entity_UserService.service, Entity_Service.serviceCat, Entity_Service.serviceCat, Entity_ServiceCat.name].join('.'))
      .selects([Entity_UserService.service, Entity_Service.serviceCat, Entity_Service.serviceCat, Entity_ServiceCat.isProgram].join('.'))

      .selects([Entity_UserService.service, Entity_Service.serviceCat, Entity_Service.serviceCat, Entity_Service.serviceCat, Entity_ServiceCat.id].join('.'))
      .selects([Entity_UserService.service, Entity_Service.serviceCat, Entity_Service.serviceCat, Entity_Service.serviceCat, Entity_ServiceCat.name].join('.'))
      .selects([Entity_UserService.service, Entity_Service.serviceCat, Entity_Service.serviceCat, Entity_Service.serviceCat, Entity_ServiceCat.isProgram].join('.'))

      .selects([Entity_UserService.service, Entity_Service.serviceCat, Entity_Service.serviceCat, Entity_Service.serviceCat, Entity_Service.serviceCat, Entity_ServiceCat.id].join('.'))
      .selects([Entity_UserService.service, Entity_Service.serviceCat, Entity_Service.serviceCat, Entity_Service.serviceCat, Entity_Service.serviceCat, Entity_ServiceCat.name].join('.'))
      .selects([Entity_UserService.service, Entity_Service.serviceCat, Entity_Service.serviceCat, Entity_Service.serviceCat, Entity_Service.serviceCat, Entity_ServiceCat.isProgram].join('.'))

      .selects([Entity_UserService.service, Entity_Service.serviceCat, Entity_Service.serviceCat, Entity_Service.serviceCat, Entity_Service.serviceCat, Entity_Service.serviceCat, Entity_ServiceCat.id].join('.'))
      .selects([Entity_UserService.service, Entity_Service.serviceCat, Entity_Service.serviceCat, Entity_Service.serviceCat, Entity_Service.serviceCat, Entity_Service.serviceCat, Entity_ServiceCat.name].join('.'))
      .selects([Entity_UserService.service, Entity_Service.serviceCat, Entity_Service.serviceCat, Entity_Service.serviceCat, Entity_Service.serviceCat, Entity_Service.serviceCat, Entity_ServiceCat.isProgram].join('.'))

      rb.filterAnd([Entity_UserService.entity, Entity_UserService.user, Entity_User.id].join('.')+' = ?', this.$router.currentRoute.params.id);

      if(!this.$tools.isEmpty(this.filter.search))
        rb.filterAnd([Entity_UserService.entity, Entity_UserService.service, Entity_Service.name].join('.')+' LIKE ?', '%'+this.filter.search+'%');

      if (!this.$tools.isEmpty(this.filter.comBranchsSelected))
         rb.filterAnd([Entity_UserService.entity, Entity_UserService.service, Entity_Service.comBranch, Entity_ComBranch.id].join('.')+' in (?)', this.filter.comBranchsSelected.map(i=>i.id));

      rb.page(page).onPage(onPage)

      if (sortFields.length>0) {
        sortFields.forEach(v=>{
          if (v.field==='service.comBranch.id') {
            rb.order(v.field, v.isAsc)
            rb.order([Entity_UserService.service, Entity_Service.serviceCat, Entity_Service.serviceCat, Entity_ServiceCat.id].join('.'), true)
          } else {
            rb.order([Entity_UserService.service, Entity_Service.serviceCat, Entity_Service.serviceCat, Entity_ServiceCat.id].join('.'), true)
            rb.order(v.field, v.isAsc)
          }
        });
      } else {
         rb.order([Entity_UserService.service, Entity_Service.serviceCat, Entity_Service.serviceCat, Entity_ServiceCat.id].join('.'), true)
      }

      rb.addStateCallback((v)=>{
        this.services = v.items
      })

      return rb;
    },
    serviceCreatedUpdatedDeleted(){
      this.$refs.table.load(true);
    },
    servicesSelectAction(v){
      this.servicesSelect = v;
    },
    createAction(){
      let arr = [];
      this.servicesSelect.forEach((v)=>{
        arr.push(v.id);
      });

      this.createState.stateLoading();
      axios.post(Api.host+'/service/user/', {
        userId:this.$router.currentRoute.params.id,
        services:arr,
        // duration:this.createState.modalData.userServicesDuration,
        // priceTotal:this.createState.modalData.userServicesPriceTotal
      })
          .then((r) =>{
            this.userServices = r.data;
            this.createState.stateSuccess();
            this.createState.modalClose();
            // this.$refs.servicesEl.selectedClear();
            this.$refs.table.load(true);
          })
          .catch(e =>{
            Api.responseError(e)
            this.createState.stateError();
          });
    },
    deleteUserService(userService){
      this.deleteState.stateLoading();
      axios.delete(Api.host+'/userService/'+userService.id+'/')
          .then(() =>{
            this.deleteState.stateSuccess();
            this.updateState.modalClose();
            this.$refs.table.load(true);
          })
          .catch(e =>{
            Api.responseError(e)
            this.deleteState.stateError();
          });
    },
    updateUserService(v){
      this.updateState.stateLoading();
      axios.put(Api.host+'/userService/'+v.id+'/', {
        duration:this.updateState.modalData.duration,
        priceTotal:this.updateState.modalData.priceTotal,
        isBaseService:this.updateState.modalData.isBaseService,
      })
      .then(() =>{
        this.updateState.modalClose();
        this.updateState.stateSuccess();
        this.$refs.table.load(true);
      })
      .catch(e =>{
        Api.responseError(e)
        this.updateState.stateError();
      });
    },
    copyUserService() {
      this.copyState.stateLoading();
      let data = {
        sourceUserId: parseInt(this.$router.currentRoute.params.id),
        targetUserId: parseInt(this.copyState.modalData.id)
      }
      if (this.servicesSelects.length>0)
          data.userServicesIds = this.servicesSelects.map(i=>i.id)

      axios.put(Api.host+'/service/user/multiple/', data)
      .then(() =>{
        this.servicesSelects = [];
        this.copyState.modalClose();
        this.copyState.stateSuccess();
        this.$store.commit('alertSuccess', 'Услуги успешно скопированы')
        this.$refs.table.load(true);
      })
      .catch(e =>{
        Api.responseError(e)
        this.copyState.stateError();
      });
    },
    userServicesDelete() {
      let userId = parseInt(this.$router.currentRoute.params.id)
      let userServicesIds = this.servicesSelects.map(i=>i.id).join(',')

      Api.service.service.userServicesDelete(userId,userServicesIds, ()=>{
        this.$refs.table.load();
      }, (e)=>{
          Api.responseError(e)
          console.error(e);
      });
    }
  }
};
</script>

<style lang="scss">
.userServices tr{
  th, td {
    width: 100px !important;
    white-space: nowrap !important;
  }
  th:nth-child(2), td:nth-child(2) {
    width: 100% !important;
  }
}
</style>

